const setInventory = (state, inventory) => (state.inventory = inventory);

const setInventories = (state, inventories) =>
  (state.inventories = inventories);

const setInventoriesWithoutPagination = (state, inventories_without_pagination) =>
  (state.inventories_without_pagination = inventories_without_pagination);

let mutations = {
  setInventory,
  setInventories,
  setInventoriesWithoutPagination
};

export default mutations;
